__turbopack_context__.v({
  "admin": "Ho9lYW_admin",
  "adminMain": "Ho9lYW_adminMain",
  "adminPanel": "Ho9lYW_adminPanel",
  "advertisingCookies": "Ho9lYW_advertisingCookies",
  "agreement": "Ho9lYW_agreement",
  "agreementBox": "Ho9lYW_agreementBox",
  "btw": "Ho9lYW_btw",
  "buy": "Ho9lYW_buy",
  "check": "Ho9lYW_check",
  "checkbox": "Ho9lYW_checkbox",
  "checkboxLabel": "Ho9lYW_checkboxLabel",
  "cookieInfoBox": "Ho9lYW_cookieInfoBox",
  "cookiePolicy": "Ho9lYW_cookiePolicy",
  "downloadAgreement": "Ho9lYW_downloadAgreement",
  "explanation": "Ho9lYW_explanation",
  "imageNote": "Ho9lYW_imageNote",
  "infoTitle": "Ho9lYW_infoTitle",
  "languageFR": "Ho9lYW_languageFR",
  "languageNL": "Ho9lYW_languageNL",
  "languagePage": "Ho9lYW_languagePage",
  "languagePicker": "Ho9lYW_languagePicker",
  "line": "Ho9lYW_line",
  "loadingPlaceholder": "Ho9lYW_loadingPlaceholder",
  "logo": "Ho9lYW_logo",
  "main": "Ho9lYW_main",
  "nameSelection": "Ho9lYW_nameSelection",
  "necessaties": "Ho9lYW_necessaties",
  "number": "Ho9lYW_number",
  "numberAndText": "Ho9lYW_numberAndText",
  "otherCookies": "Ho9lYW_otherCookies",
  "page": "Ho9lYW_page",
  "photoUpload": "Ho9lYW_photoUpload",
  "pointTitle": "Ho9lYW_pointTitle",
  "points": "Ho9lYW_points",
  "priceIn": "Ho9lYW_priceIn",
  "promoBox": "Ho9lYW_promoBox",
  "promoContent": "Ho9lYW_promoContent",
  "promoContentFR": "Ho9lYW_promoContentFR",
  "promoContentNL": "Ho9lYW_promoContentNL",
  "promoTitle": "Ho9lYW_promoTitle",
  "promotionPanel": "Ho9lYW_promotionPanel",
  "questions": "Ho9lYW_questions",
  "rent": "Ho9lYW_rent",
  "reserve": "Ho9lYW_reserve",
  "spamMessage": "Ho9lYW_spamMessage",
  "success": "Ho9lYW_success",
  "transportPrice": "Ho9lYW_transportPrice",
  "welcomeBox": "Ho9lYW_welcomeBox",
  "widthNecessecity": "Ho9lYW_widthNecessecity",
});
